import { render, staticRenderFns } from "./NotificationsTypes.html?vue&type=template&id=009f2d0c&external"
import script from "./NotificationsTypes.js?vue&type=script&lang=js&external"
export * from "./NotificationsTypes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports